import React from 'react'
import CategoryMultiplierItem from './CategoryMultiplierItem'
import LoadingSkeleton from './LoadingSkeleton'

export default function FormCategoryMultiplier(props) {
    const {
        categoriesLoading,
        categoriesLoadingIndicator,

        categories,
        handleCategoryNameClick,
        handleExpandCategory } = props
    return (
        <div id="app-category-multiplier-view">
            <div className="inner">
                {
                    categoriesLoading && (
                        <React.Fragment>
                            {
                                categoriesLoadingIndicator?.length ? categoriesLoadingIndicator.map(item => (
                                    <React.Fragment key={item}>
                                        <LoadingSkeleton />
                                    </React.Fragment>
                                )) : null
                            }
                        </React.Fragment>
                    )
                }
                {
                    categories?.length ? categories.map((item, index) => {
                        return (
                            <React.Fragment key={item.category_id}>
                                <CategoryMultiplierItem
                                    {...props}
                                    categoryItem={item}
                                    categoryItemIndex={index}

                                    handleCategoryNameClick={(ev, id) => handleCategoryNameClick(ev, id)}
                                    handleExpandCategory={(ev, id) => handleExpandCategory(ev, id)}
                                />
                            </React.Fragment>
                        )
                    }) : (
                        <p className="no-data-found">No data found</p>
                    )
                }
            </div>
        </div>
    )
}
